<template>
  <div>
    <div class="row">
      <div class="form-group col-4 d-flex my-4">
        <input
          id="filtro"
          type="text"
          class="form-control"
          :placeholder="
            this.$t('menu.settings.alertsNewsletters.placeholderSearch')
          "
          v-model="filter"
          @keyup="handleFilter"
        />
        <button @click="cleanFilter" class="btn btn-outline-primary">
          {{ $t('menu.settings.alertsNewsletters.buttonClear') }}
        </button>
      </div>
    </div>
    <div class="text-center text-primary my-2" v-if="loadingBranches">
      <b-spinner type="grow" class="align-middle"></b-spinner>
    </div>
    <div v-else>
      <b-table
        striped
        :items="branchItems.branches"
        :fields="fields"
        responsive
      >
        <template v-slot:cell(rule)="row">
          <p :class="row.item.rule ? 'text-dark' : 'text-danger'">
            {{
              row.item.rule
                ? $t('menu.settings.alertsNewsletters.yesLabel')
                : $t('menu.settings.alertsNewsletters.noLabel')
            }}
          </p>
        </template>

        <template v-slot:cell(updatedAt)="row">
          <p>{{ row.item.updatedAt ? formatDate(row.item.updatedAt) : '-' }}</p>
        </template>

        <template v-slot:cell(options)="row">
          <div>
            <div v-if="!row.item.rule">
              <button
                v-b-modal="`modal-alert-rule-branch-${row.item.branchId}`"
                class="btn btn-outline-primary"
              >
                <modal-alert-rule-branch
                  :mainRuleId="alertId"
                  :branchData="row.item"
                  :page="page"
                  :filter="filter"
                />
                <font-awesome-icon :icon="['fas', 'plus']" />
              </button>
            </div>
            <div v-else>
              <button
                @click="deleteRule(row.item)"
                class="btn btn-outline-danger"
              >
                <font-awesome-icon :icon="['fas', 'trash-alt']" />
              </button>
              <button
                v-b-modal="`modal-alert-rule-branch-edit-${row.item.branchId}`"
                class="btn btn-outline-primary"
              >
                <modal-alert-rule-branch-edit
                  :mainRuleId="alertId"
                  :branchData="row.item"
                  :page="page"
                  :filter="filter"
                />
                <font-awesome-icon :icon="['fas', 'pen']" />
              </button>
            </div>
          </div>
        </template>
      </b-table>
    </div>

    <div class="pagination-area-answers">
      <paginate
        v-model="page"
        :pageCount="Math.ceil(branchItems.total / limit)"
        :clickHandler="getBranches"
        :prevText="'‹'"
        :nextText="'›'"
        :activeClass="'active'"
        :containerClass="'pagination b-pagination'"
        :pageClass="'page-item'"
      ></paginate>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import api from '../../../../../../services/api';
import modalAlertRuleBranch from '../../../../../molecules/modal-alert-rule-branch';
import modalAlertRuleBranchEdit from '../../../../../molecules/modal-alert-rule-branch-edit';

export default {
  components: {
    modalAlertRuleBranch,
    modalAlertRuleBranchEdit,
    Paginate,
  },

  computed: {
    ...mapState('alertRules', ['alertId', 'branchItems']),
    ...mapFields('alertRules', ['loadingBranches']),
  },

  data: () => ({
    loading: false,
    page: 1,
    limit: 10,
    filter: null,
    userAuth: null,
    fields: [],
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'name',
        label: this.$t('menu.settings.alertsNewsletters.table.branch'),
      },
      {
        key: 'rule',
        label: this.$t('menu.settings.alertsNewsletters.table.hasAlert'),
        class: 'center-data',
      },
      {
        key: 'updatedAt',
        label: this.$t('menu.settings.alertsNewsletters.table.updated'),
        class: 'center-data',
      },
      {
        key: 'options',
        label: this.$t('menu.settings.alertsNewsletters.table.options'),
        class: 'center-data',
      },
    ];
  },

  methods: {
    ...mapActions('alertRules', ['getBranchRules']),

    async cleanFilter() {
      this.filter = null;
      await this.getBranches();
    },

    async getBranches() {
      this.loadingBranches = true;
      await this.getBranchRules({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        mainRuleId: this.alertId,
        params: {
          filter: this.filter,
          page: this.page,
          limit: this.limit,
        },
      });
      this.loadingBranches = false;
    },

    async handleFilter() {
      this.page = 1;
      await this.getBranches();
    },

    deleteRule(rule) {
      swal({
        title: this.$t(
          'menu.settings.alertsNewsletters.messages.deleteBranchRule.title',
        ),
        text: `${this.$t(
          'menu.settings.alertsNewsletters.messages.deleteBranchRule.description',
        )} ${rule.name}?`,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(
            `${process.env.API_ROOT}/branch-alert-rules/${this.userAuth.companyId}/${rule.rule}`,
            {
              headers: { 'x-access-token': this.userAuth.token },
            },
          );
          await this.getBranches();
          await swal({
            title: this.$t(
              'menu.settings.alertsNewsletters.messages.deleteBranchRule.deletedOkTitle',
            ),
            text: `${this.$t(
              'menu.settings.alertsNewsletters.messages.deleteBranchRule.deletedOkMsg1',
            )} ${rule.name} ${this.$t(
              'menu.settings.alertsNewsletters.messages.deleteBranchRule.deletedOkMsg2',
            )}`,
            icon: 'success',
          });
        }
      });
    },

    formatDate(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const time = lightFormat(new Date(param), 'HH:mm');
      return `${day} às ${time}`;
    },
  },
};
</script>

<style scoped>
.center-data {
  text-align: center;
}

.pagination-area-answers >>> a {
  position: relative;
  display: block;
  padding: 10px;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
  outline: none;
}

.pagination-area-answers >>> .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background: #4ce595;
  border-color: #4ce595;
  outline: none;
}

.pagination-area-answers a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/settings-alert-rules/new-rule/tab-branch/index.vue